module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container p-0"
  }, [_c('b-card', {
    attrs: {
      "no-block": "",
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('userRegistration.registrationHeader')
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('datatable', {
    attrs: {
      "url": _vm.registrationsUrl,
      "reportsUrl": _vm.registrationsReportsUrl,
      "columns": _vm.tColumns,
      "options": _vm.tOptions
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-sm",
          class: {
            'btn-info': props.row.status === _vm.RegistrationStatus.PENDING, 'btn-success': props.row.status === _vm.RegistrationStatus.APPROVED, 'btn-danger': props.row.status === _vm.RegistrationStatus.CANCELLED
          }
        }, [_vm._v(_vm._s(_vm.$t('userRegistration.registrationStatuses.' + props.row.status)))])]
      }
    }, {
      key: "entityType",
      fn: function(props) {
        return [(props.row.entityType === 1000) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(props.row.entityType))])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8f341b20", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f341b20","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/user-registration/UserRegistration.vue
// module id = 800
// module chunks = 1